import React, { useState, useEffect } from 'react';
import config from '../../config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle} from '@fortawesome/free-solid-svg-icons';
import BannerModal from '../../components/BannerModal';

const AdManagement = ({ restaurantId }) => {
  const { API_URL } = config;
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [filterType, setFilterType] = useState('All');
  const [confirmModal, setConfirmModal] = useState({ show: false, id: null, status: '' });
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const response = await fetch(`${API_URL}/api/adds/getAdds`);
        const data = await response.json();
        if (data.status === 'success') {
          setAds(data.adds);
          console.log(data.adds)
        } else {
          console.error('Failed to fetch ads');
        }
      } catch (error) {
        console.error('Error fetching ads:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchAds();
  }, [restaurantId]);

  const changeStatus = async (adId, newStatus) => {
    try {
      const response = await fetch(`${API_URL}/api/adds/updateAddsStatus/${adId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          restaurantId,
          status: newStatus,
        }),
      });
      const result = await response.json();
      if (result.status === 'success') {
        setAds(prevAds =>
          prevAds.map(ad =>
            ad._id === adId ? { ...ad, status: newStatus } : ad
          )
        );
      } else {
        console.error('Failed to update ad status');
      }
    } catch (error) {
      console.error('Error updating ad status:', error);
    }
  };

  const openImageModal = (bannerLink) => {
    setSelectedImage(bannerLink);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedImage('');
  };

  const openConfirmModal = (id, status) => {
    setConfirmModal({ show: true, id, status });
  };

  const closeConfirmModal = () => {
    setConfirmModal({ show: false, id: null, status: '' });
  };

  const confirmChangeStatus = () => {
    changeStatus(confirmModal.id, confirmModal.status);
    closeConfirmModal();
  };

  const getStatusClass = (status) => {
    switch (status.toLowerCase()) {
      case 'active':
        return 'bg-green-100 text-green-700';
      case 'inactive':
        return 'bg-red-100 text-red-700';
      case 'pending':
        return 'bg-yellow-100 text-yellow-700';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  };

   const handleOpenModal = () => setIsModalOpen(true);
   const handleCloseModal = () => setIsModalOpen(false);
 
  const filteredAds = filterType === 'All' ? ads : ads.filter(ad => ad.type === filterType);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Ads Management</h1>

      <div className="mb-4 flex items-center justify-between gap-4">

        <div>
        <label className="font-medium mr-2">Filter by Type:</label>
        <select
          className="p-2 border rounded-lg"
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
        >
          <option value="All">All</option>
          <option value="user">User</option>
          <option value="rider">Rider</option>
          <option value="restaurant">Restaurant</option>
          <option value="admin">Admin</option>
        </select>
        </div>

        <button onClick={handleOpenModal} type="button" className="border border-[#BACAF4] text-[#0F60FF] text-[15px] leading-[17.63px] rounded-[7px] font-medium py-2 px-4 flex justify-center items-center hover:bg-blue-100 hover:font-semibold">
          Add Banner
          <FontAwesomeIcon icon={faPlusCircle} className="ml-2 text-[#04CF31] w-7 h-7" />
        </button>
        <BannerModal isOpen={isModalOpen} onClose={handleCloseModal} />

      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-6 py-3 text-left font-medium text-gray-700">Title</th>
              <th className="px-6 py-3 text-left font-medium text-gray-700">Description</th>
              <th className="px-6 py-3 text-left font-medium text-gray-700">Status</th>
              <th className="px-6 py-3 text-left font-medium text-gray-700">Type</th>
              <th className="px-6 py-3 text-left font-medium text-gray-700">Amount Paid</th>
              <th className="px-6 py-3 text-left font-medium text-gray-700">Banner</th>
              <th className="px-6 py-3 text-left font-medium text-gray-700">Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredAds.map(ad => (
              <tr key={ad._id} className="border-t">
                <td className="px-6 py-4 text-gray-800">{ad.title || 'N/A'}</td>
                <td className="px-6 py-4 text-gray-800">{ad.description || 'N/A'}</td>
                <div>
                  <td className={`px-6 py-2 rounded-lg ${getStatusClass(ad.status || 'N/A')}`}>{ad.status || 'N/A'}</td>
                </div>
                <td className="px-6 py-4 text-gray-800">{ad.type || 'N/A'}</td>
                <td className="px-6 py-4 text-gray-800">{ad.amountPaid ? `₹${ad.amountPaid}` : 'N/A'}</td>
                <td className="px-6 py-4">
                  <button
                    onClick={() => openImageModal(ad.bannerLink)}
                    className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600"
                  >
                    Banner
                  </button>
                </td>
                <td className="px-6 py-4 flex gap-2">
                  <button
                    onClick={() => openConfirmModal(ad._id, 'active')}
                    className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                  >
                    Active
                  </button>
                  <button
                    onClick={() => openConfirmModal(ad._id, 'inactive')}
                    className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
                  >
                    Inactive
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {confirmModal.show && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-xl">
            <h2 className="text-xl font-bold mb-4">Confirm Action</h2>
            <p className="mb-4">Are you sure you want to set this ad to <span className="font-semibold">{confirmModal.status}</span>?</p>
            <div className="flex justify-end gap-4">
              <button
                onClick={closeConfirmModal}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={confirmChangeStatus}
                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-4 rounded-lg relative shadow-xl">
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-2xl text-gray-700 hover:text-gray-900"
            >
              &times;
            </button>
            <img
              src={selectedImage}
              alt="Ad Banner"
              className="max-w-full max-h-[80vh] object-contain"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AdManagement;
